import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post/purple-post-digital-reply';

export default {
  getAll(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/resident${queryString}`);
  },
  getRepliesByPostId(postId) {
    return axios.get(`${base}/post/${postId}`);
  },
  getSingleReply(id) {
    return axios.get(`${base}/reply/${id}`);
  },
  sendReply(message, postId) {
    return axios.post(`${base}/create`, {
      message, post_id: postId,
    });
  },
};
